module.exports = __webpack_public_path__ + "images/emoji/hammer.5324cad5fcc6725cb47c.png";